const initialState = () => ({
  isMyAccountViewActive: false,
  isSecurityPermitsViewActive: false,
});

const state = initialState();

export default state;
